import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';

void i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    fallbackLng: ['en', 'nl'], // first en then nl
    supportedLngs: ['en', 'nl'],
    debug: process.env.VITE_ENV !== 'prod',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    pluralSeparator: '_',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: '/static/locales/{{lng}}.json',
    },
    react: {
      useSuspense: false,
    },
    parseMissingKeyHandler: () =>
      process.env.VITE_ENV === 'prod'
        ? 'Translation not found'
        : 'TRANSLATION_NOT_FOUND',
  });

export { default } from 'i18next';
